import { createTextMask } from 'redux-form-input-masks';

export const ROLES = {
  ADMIN: 'ADMIN',
  PRACTITIONER: 'PRACTITIONER',
  PATIENT: 'PATIENT',
  STAFF: 'STAFF',
  RADIOLOGY: 'RADIOLOGY'
};

//──── payment methods ───────────────────────────────────────────────────────────────────
export const IN_APP_PAYMENT = 'InApp';
export const RECEPTION_BANK_CONTACT = 'ReceptionBankContact';
export const RECEPTION_CARD = 'ReceptionVisaOrMasterCard';
export const RECEPTION_CASH = 'ReceptionCash';
export const RECEPTION_INVOICE = 'ReceptionInvoice';
export const RECEPTION_DEBT = 'ReceptionOcmwDebtMediation';
export const RECEPTION_WORK_ACCIDENT = 'ReceptionWorkAccident';
export const RECEPTION_HOSPITAL_ADMISSION = 'ReceptionHospitalAdmission';
export const PRO_DEO = 'ProDeo';

export const TAB_PATIENT = 'patient';
export const TAB_INVOICE = 'invoice';
export const TAB_PAYMENTS = 'payments';

//──── Appointment status ────────────────────────────────────────────────────────────────
export const STATUS_ARRIVED = 'patient_arrived';
export const STATUS_BOOKED = 'consultation_booked';
export const STATUS_CANCELLED = 'consultation_canceled';
export const STATUS_CANCELLED_FROM_COVID = 'consultation_staff_canceled_by_covid'; // temporary value - used only filters (don't get it from beck end)
export const STATUS_COMPLETED = 'Complited';
export const STATUS_CONSULTATION_RESTARTED = 'consultation_restarted';
export const STATUS_CONSULTATION_REVIEWED = 'consultation_reviewed';
export const STATUS_CONSULTATION_STARTED_AFTER_RADIOLOGY = 'consultation_started_after_radiology';
export const STATUS_FINISH = 'consultation_finish';
export const STATUS_FINISHED = 'consultation_finished';
export const STATUS_IN_PROGRESS = 'InProgress';
export const STATUS_NO_SHOW = 'consultation_nowshow';
export const STATUS_PAID = 'consultation_paid';
export const STATUS_RADIOLOGY_FINISHED = 'radiology_finished';
export const STATUS_RADIOLOGY_FINISHED_DURING = 'radiology_finished_during_consultation';
export const STATUS_RADIOLOGY_START = 'radiology_start';
export const STATUS_RADIOLOGY_STARTED = 'radiology_started';
export const STATUS_RADIOLOGY_STARTED_DURING = 'radiology_started_during_consultation';
export const STATUS_RADIOLOGY_START_DURING_CONSULTATION = 'radiology_start_during_consultation';
export const STATUS_REPLACED = 'consultation_replaced';
export const STATUS_SELF_ARRIVED = 'patient_self_arrive';
export const STATUS_STARTED = 'consultation_started';
export const STATUS_SUSPENDED = 'consultation_suspended';

export const PAYMENT_STATUS_OPEN = 'Open';
export const PAYMENT_STATUS_PAID = 'Paid';

export const APPOINTMENTS_TODAY = 'TODAY';
export const APPOINTMENTS_PLANNING = 'PLANNING';
export const APPOINTMENTS_SCHEDULES = 'SCHEDULES';

export const PATIENT_VALIDATED = 'Validated';
export const PATIENT_NOT_VALIDATED = 'NotValidated';
export const PATIENT_BLOCKED = 'Blocked';

//──── Masks ─────────────────────────────────────────────────────────────────────────────
export const nationalNumberMask = createTextMask({
  pattern: '999999-999.99'
});

export const phoneMask = createTextMask({
  pattern: '+32 (0)499 99 99 99'
});

export const genderList = [
  { value: 'male', translateLabel: 'gender_male' },
  { value: 'female', translateLabel: 'gender_female' },
  { value: 'other', translateLabel: 'gender_other' }
];

export const phonePrefix = '+324';
